import React from "react";
import { Box, LinearProgress, Paper, alpha } from "@mui/material";

export function Card({
  children,
  elevation = 1,
  loading = false,
  sx,
  className,
}) {
  return (
    <Box
      position="relative"
      display="flex"
      flexDirection="column"
      gap={2}
      sx={{ p: 2.5, height: "100%", ...sx }}
      component={Paper}
      elevation={elevation}
      className={className}
    >
      {loading && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            bgcolor: (theme) => alpha(theme.palette.grey[50], 0.5),
            zIndex: 1,
          }}
        >
          <LinearProgress />
        </Box>
      )}
      {children}
    </Box>
  );
}
